import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import api from './api';
import router from './router';

Vue.use(Vuex);

const createStorage = createPersistedState({
  key: 'olms-check',
  storage: sessionStorage,
  reducer(val) {
    if (val.user === null) {
      sessionStorage.removeItem('olms-check');
      return {};
    }
    return val;
  },
  paths: [
    'user',
    'curUser',
    'semester',
    'semesters',
    'teachers',
    'experiments',
    'courses',
    'lessons',
    'students',
    'orgs',
    'elective',
    'electives',
    'deductions',
    'deductionMarks',
    'deductionStatus',
    'deductionTypes'
  ]
});

export default new Vuex.Store({
  state: {
    // data state
    config: {},
    user: null,
    curUser: null,
    semester: '',
    semesters: [],
    teacher: null,
    teachers: [],
    experiment: null,
    experiments: [],
    address: null,
    addresses: [],
    courses: [],
    lessonOptions: {},
    lesson: null,
    lessons: [],
    selectedLessons: [],
    studentOptions: {},
    students: [],
    selectedStudents: [],
    orgOptions: {},
    orgs: [],
    selectedOrgs: [],
    elective: null,
    electives: [],
    deduction: null,
    deductionHistory: [],
    deductions: [],
    hangingDrawdeduction: null,
    sendbackPoints: [],
    deductionMarks: [],
    deductionStatus: [],
    deductionTypes: [],
    selectedItem: null,
    reports: [],
    checkReports: [],
    curCanvasIndex: 0,
    canvasArray: [],
    // app view state
    alert: false,
    alertColor: 'success',
    alertMessage: '',
    alertTimeout: 2000,
    confirmShow: false,
    confirmMessage: '',
    pendingConfirm: false,
    confirmAction: () => {},
    createDeductionShow: false,
    changeDeductionTypeShow: false,
    changePasswordShow: false,
    sendbackPointsShow: false,
    todoDrawer: false,
    workingDrawer: true,
    showEditPanel: false,
    drawerType: 'schedule',
    curDrawerType: 'schedule',
    isOrg: false,
    // 是否允许创建公共扣分项
    allowPublicDeductionPoint: true,
    // 是否显示无教师场次
    noTeacherChecked: false,
    // 初始化完毕
    init: false,
    histories: [],
    originalU2p: null,
    originalSchedule: [],
    curNum: 0,
    limit: 10,
    offset: 0,
    ending: false
  },
  mutations: {
    login(state, user) {
      state.user = user;
    },
    logout(state) {
      state.user = null;
    },
    updateConfig(state, config) {
      state.config = config;
    },
    updateCurUser(state, user) {
      state.curUser = user;
    },
    setSemesters(state, semesters) {
      state.semesters = semesters;
    },
    setSemester(state, semester) {
      state.semester = semester;
    },
    setTeacher(state, teacher) {
      state.teacher = teacher;
    },
    setTeachers(state, teachers) {
      state.teachers = teachers;
    },
    setExperiment(state, experiment) {
      state.experiment = experiment;
    },
    setCourses(state, courses) {
      state.courses = courses;
    },
    setExperiments(state, experiments) {
      state.experiments = experiments;
    },
    setLessonOptions(state, options) {
      state.lessonOptions = options;
    },
    setLessons(state, lessons) {
      state.lessons = lessons;
    },
    setSelectedLessons(state, lessons) {
      state.selectedLessons = lessons;
    },
    setStudentOptions(state, options) {
      state.studentOptions = options;
    },
    setStudents(state, students) {
      state.students = students;
    },
    setSelectedStudents(state, students) {
      state.selectedStudents = students;
    },
    setOrgOptions(state, options) {
      state.orgOptions = options;
    },
    setOrgs(state, orgs) {
      state.orgs = orgs;
    },
    setSelectedOrgs(state, orgs) {
      state.selectedOrgs = orgs;
    },
    setElective(state, elective) {
      state.elective = elective;
    },
    setElectives(state, electives) {
      state.electives = electives;
    },
    addElectives(state, payload) {
      state.electives.push({
        name: payload.name,
        electives: payload.electives
      });
    },
    setDeduction(state, deduction) {
      state.deduction = deduction;
    },
    setSelectedItem(state, item) {
      state.selectedItem = item;
    },
    setDeductionMarks(state, deductionMarks) {
      state.deductionMarks = deductionMarks;
    },
    setDeductionStatus(state, deductionStatus) {
      state.deductionStatus = deductionStatus;
    },
    setDeductions(state, deductions) {
      state.deductions = Array.from(deductions.entries())
        .map(item => {
          return item.map(item => {
            return Array.isArray(item)
              ? item
                  .map(item => {
                    return {
                      ...item,
                      score:
                        item.scores && item.scores.length ? item.scores[0] : 0
                    };
                  })
                  // 管理系统 -> 教学中心 -> 基础数据 -> 参数设置 -> 批改设置
                  // 按公开和私有评分项设置过滤评分参考
                  .filter(item => {
                    // 私有评分项可编辑和允许提交私有评分项
                    if (
                      state.config.enableEditingPrivate &&
                      state.config.enableSubmitPrivate
                    ) {
                      // 中心管理员可以查看公有评分项和教师提交过的评分项
                      if (state.user.role === 'centreadmin') {
                        return (
                          item.pub_status.dictkey === 'public' ||
                          item.pub_status.dictkey === 'preview'
                        );
                      }
                      // 教师可以查看公有评分项和自己创建的私有评分项和自己提交过的评分项
                      else if (state.user.role === 'teacher') {
                        return (
                          item.pub_status.dictkey === 'public' ||
                          ((item.pub_status.dictkey === 'private' ||
                            item.pub_status.dictkey === 'preview') &&
                            item.user_id === state.user.id)
                        );
                        // 助教可以查看公开评分项和本场次教师的私有评分项
                      } else {
                        return (
                          item.pub_status.dictkey === 'public' ||
                          (item.pub_status.dictkey === 'private' &&
                            item.user_id ===
                              state.elective.schedules.teacher_id)
                        );
                      }
                      // 私有评分项可编辑
                    } else if (state.config.enableEditingPrivate) {
                      // 教师角色可以查看公开评分项和自己创建的私有评分项
                      if (state.user.role === 'teacher') {
                        return (
                          item.pub_status.dictkey === 'public' ||
                          (item.pub_status.dictkey === 'private' &&
                            item.user_id === state.user.id)
                        );
                        // 助教可以查看公开评分项和本场次教师的私有评分项
                      } else if (state.user.role === 'assistant') {
                        return (
                          item.pub_status.dictkey === 'public' ||
                          (item.pub_status.dictkey === 'private' &&
                            item.user_id ===
                              state.elective.schedules.teacher_id)
                        );
                        // 中心管理员可以查看公开评分项
                      } else {
                        return item.pub_status.dictkey === 'public';
                      }
                    } else {
                      return item.pub_status.dictkey === 'public';
                    }
                  })
              : item;
          });
        })
        .sort((a, b) => {
          if (a[0].split('.')[0] !== b[0].split('.')[0]) {
            return a[0].split('.')[0] - b[0].split('.')[0];
          } else return a[0].split('.')[1].localeCompare(b[0].split('.')[1]);
        });

      state.deductionTypes = state.deductions
        .filter(item => item[1].length)
        .map(item => item[0])
        .sort((a, b) => {
          if (a.split('.')[0] !== b.split('.')[0]) {
            return a.split('.')[0] - b.split('.')[0];
          } else return a.split('.')[1].localeCompare(b.split('.')[1]);
        });
    },
    setHangingDrawdeduction(state, deduction) {
      state.hangingDrawdeduction = deduction;
    },
    setSendbackPoints(state, sendbackPoints) {
      state.sendbackPoints = sendbackPoints;
    },
    setReports(state, reports) {
      state.reports = reports;
    },
    setCheckReports(state, reports) {
      state.checkReports = reports;
    },
    setAlert(state, { message, color }) {
      state.alert = true;
      state.alertColor = color ? color : 'success';
      state.alertMessage = message;
    },
    resetAlert(state) {
      state.alert = false;
      state.alertColor = 'success';
      state.alertMessage = '';
    },
    setConfirm(state, message) {
      if (message && message !== '') {
        state.confirmShow = true;
        state.confirmMessage = message;
      } else {
        state.confirmShow = false;
        state.confirmMessage = '';
      }
    },
    setPendingConfirm(state, status) {
      state.pendingConfirm = status;
    },
    // action should be Promise
    setConfirmAction(state, action) {
      state.confirmAction = action;
    },
    setDeductionShow(state, status) {
      state.createDeductionShow = status;
    },
    setDeductionTypeShow(state, status) {
      state.changeDeductionTypeShow = status;
    },
    setChangePasswordShow(state, status) {
      state.changePasswordShow = status;
    },
    setSendbackPointsShow(state, status) {
      state.sendbackPointsShow = status;
    },
    toggleTodoDrawer(state, status) {
      state.todoDrawer = status;
    },
    toggleWorkingDrawer(state, status) {
      state.workingDrawer = status;
    },
    toogleEditPanel(state) {
      state.showEditPanel = !state.showEditPanel;
    },
    setDeductionHistory(state) {
      if (
        state.deductionHistory.length === 0 &&
        localStorage.getItem('deductionHistory') &&
        !state.hangingDrawdeduction
      ) {
        state.deductionHistory = JSON.parse(
          localStorage.getItem('deductionHistory')
        );
      } else if (state.hangingDrawdeduction) {
        let index = state.deductionHistory.findIndex(item => {
          return item.deduction.id === state.hangingDrawdeduction.id;
        });

        if (index === -1) {
          state.deductionHistory.unshift({
            deduction: state.hangingDrawdeduction,
            count: 1
          });
        } else state.deductionHistory[index].count++;

        localStorage.setItem(
          'deductionHistory',
          JSON.stringify(state.deductionHistory)
        );
      }
    },
    setDrawerType(state, type) {
      state.drawerType = type;
    },
    setCurDrawerType(state, type) {
      state.curDrawerType = type;
    },
    setIsOrg(state, status) {
      state.isOrg = status;
    },
    setHistories(state, histories) {
      state.histories = histories;
    },
    setOriginalU2p(state, originalU2p) {
      state.originalU2p = originalU2p;
    },
    setOriginalSchedule(state, originalSchedule) {
      state.originalSchedule = originalSchedule;
    },
    setCurNum(state, curNum) {
      state.curNum = curNum;
    },
    setOffset(state, offset) {
      state.offset = offset;
    },
    setEnding(state, ending) {
      state.ending = ending;
    },
    setCurCanvasIndex(state, index) {
      state.curCanvasIndex = index;
    },
    setCanvasArray(state, canvasArray) {
      state.canvasArray = canvasArray;
    }
  },
  getters: {
    expandDrawer: () => {
      return window && window.innerWidth >= 1440;
    },
    loggedIn: state => state.user !== null,
    config: state => state.config,
    user: state => state.user,
    curUser: state => state.curUser,
    semester: state => {
      return state.semester;
    },
    semesters: state => {
      return state.semesters;
    },
    teachers: state => {
      return state.teachers;
    },
    courses: state => {
      return state.courses;
    },
    experiment: state => {
      return state.experiment;
    },
    experiments: state => {
      return state.experiments;
    },
    lessonOptions: state => {
      return state.lessonOptions;
    },
    lesson: state => {
      return state.lesson;
    },
    // 可批阅场次列表(默认全部), 按上课时间升序(先上的先批阅)且有教师的在前
    lessons: state => {
      const filterLessons = state.noTeacherChecked
        ? state.lessons.filter(x => x.teacher && x.teacher !== '')
        : state.lessons;
      const sortedLessons = filterLessons.sort((a, b) => {
        if (
          Date.parse(
            `${a.date.replace('-', '/')} ${a.periods.start_time}`
          ).valueOf() >
          Date.parse(
            `${b.date.replace('-', '/')} ${b.periods.start_time}`
          ).valueOf()
        ) {
          return 1;
        }

        if (
          Date.parse(
            `${a.date.replace('-', '/')} ${a.periods.start_time}`
          ).valueOf() <
          Date.parse(
            `${b.date.replace('-', '/')} ${b.periods.start_time}`
          ).valueOf()
        ) {
          return -1;
        }

        return 0;
      });
      return sortedLessons;
    },
    selectedLessons: (state, getters) => {
      if (state.selectedLessons.length === 0 && getters.lessons.length !== 0) {
        return getters.lessons.slice(0, 1);
      }
      return state.selectedLessons;
    },
    studentOptions: state => {
      return state.studentOptions;
    },
    students: state => {
      return state.students;
    },
    selectedStudents: state => {
      if (state.selectedStudents.length === 0 && state.students.length !== 0) {
        return state.students.slice(0, 1);
      } else return state.selectedStudents;
    },
    orgOptions: state => {
      return state.orgOptions;
    },
    orgs: state => {
      return state.orgs;
    },
    selectedOrgs: state => {
      if (state.selectedOrgs.length === 0 && state.orgs.length !== 0) {
        return state.orgs.slice(0, 1);
      } else return state.selectedOrgs;
    },
    elective: state => {
      return state.elective;
    },
    electives: state => {
      return state.electives;
    },
    deductionMarks: state => {
      return state.deductionMarks;
    },
    deductionStatus: state => {
      return state.deductionStatus;
    },
    deductionTypes: state => {
      return state.deductionTypes;
    },
    deduction: state => {
      return state.deduction ? state.deduction : {};
    },
    deductions: state => {
      return state.deductions;
    },
    selectedItem: state => {
      return state.selectedItem;
    },
    hangingDrawdeduction: state => {
      return state.hangingDrawdeduction;
    },
    sendbackPoints: state => {
      return state.sendbackPoints;
    },
    reports: state => {
      let reportsUrl = [];
      state.reports.forEach(url => {
        reportsUrl.push(`${url}?${Math.floor(Math.random() * 10000)}`);
      });
      return reportsUrl;
    },
    checkReports: state => {
      let reportsUrl = [];
      state.checkReports.forEach(url => {
        reportsUrl.push(`${url}?${Math.floor(Math.random() * 10000)}`);
      });
      return reportsUrl;
    },
    todoDrawer: state => {
      return state.todoDrawer;
    },
    workingDrawer: state => {
      if (window && window.innerWidth >= 1440) {
        return true;
      }
      return state.workingDrawer;
    },
    alert: state => state.alert,
    alertColor: state => state.alertColor,
    alertMessage: state => state.alertMessage,
    confirmShow: state => state.confirmShow,
    confirmMessage: state => state.confirmMessage,
    confirmAction: state => state.confirmAction,
    pendingConfirm: state => state.pendingConfirm,
    createDeductionShow: state => state.createDeductionShow,
    changeDeductionTypeShow: state => state.changeDeductionTypeShow,
    changePasswordShow: state => state.changePasswordShow,
    sendbackPointsShow: state => state.sendbackPointsShow,
    allowPublicDeductionPoint: state => state.allowPublicDeductionPoint,
    showEditPanel: state => state.showEditPanel,
    deductionHistory: state => state.deductionHistory,
    drawerType: state => state.drawerType,
    curDrawerType: state => state.curDrawerType,
    isOrg: state => state.isOrg,
    histories: state => state.histories,
    originalU2p: state => state.originalU2p,
    originalSchedule: state => state.originalSchedule,
    curNum: state => state.curNum,
    limit: state => state.limit,
    offset: state => state.offset,
    ending: state => state.ending,
    curCanvasIndex: state => state.curCanvasIndex,
    canvasArray: state => state.canvasArray
  },
  actions: {
    toogleEditPanel() {
      this.commit('toogleEditPanel');
    },
    async login({ dispatch, commit }, { username, password }) {
      api.login(
        username,
        password,
        user => {
          window && window.sessionStorage.setItem('authenticated', user.token);
          commit('login', user);
          dispatch('getConfig');
          dispatch('getCurTeacher', user);
          dispatch('init').then(() => {
            router.push('/');
          });
        },
        error => {
          dispatch('alert', {
            message: '登录失败，请稍后再试。',
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    logout({ commit }) {
      commit('logout');
      window && window.sessionStorage.removeItem('authenticated');
      window && window.localStorage.removeItem('olms-check');
      window && window.sessionStorage.removeItem('olms-check');
      router.push('/login');
    },
    async getConfig({ commit }) {
      api.getConfig(
        configs => {
          if (configs.length > 0) {
            commit('updateConfig', configs[0].value);
          }
        },
        error => {
          dispatch('alert', {
            message: '获取参数配置失败，请稍后再试。',
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async getCurTeacher({ commit }, user) {
      api.getCurTeacher(
        user.id,
        data => commit('updateCurUser', data),
        err => Promise.reject(err)
      );
    },
    async resetPassword({ dispatch }, { username, identity }) {
      await api.resetPassword(
        username,
        identity,
        async () => {
          await dispatch('alert', { message: '重置成功' });
        },
        async error => {
          await dispatch('alert', {
            message: '重置失败，请稍后再试。',
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async updatePassword({ dispatch }, password) {
      await api.updatePassword(
        password,
        async () => {
          await dispatch('alert', {
            message: '密码修改成功',
            color: 'success'
          });
        },
        async error => {
          await dispatch('alert', {
            message: error.message || '密码修改失败，请稍后再试。',
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async init({ dispatch, state, commit }) {
      return Promise.all([
        new Promise((resolve, reject) => {
          api.getSemesters(
            semesters => {
              let currentSemester = semesters.find(x => x.is_open);
              commit('setSemesters', semesters);
              commit('setSemester', currentSemester);
              dispatch('fetchCourses', {
                org_id: state.user.org,
                semester_id: currentSemester.id
              });
              dispatch('fetchProjects', {
                org_id: state.user.org,
                semester_id: currentSemester.id
              });
              Promise.all([
                new Promise((resolve, reject) => {
                  api.getLessons(
                    state.user.org,
                    '',
                    '',
                    '',
                    currentSemester.id,
                    state.user.role === 'teacher' ? state.user.id : '',
                    '',
                    '',
                    lessons => {
                      commit('setLessons', lessons);
                      if (lessons.length > 0) {
                        let selectedLessons = lessons.slice(0, 1);
                        Promise.all([
                          dispatch('selectLessons', selectedLessons),
                          dispatch(
                            'fetchDeductions',
                            selectedLessons[0].projects.code
                          )
                        ]).then(() => resolve());
                      }
                      resolve();
                    },
                    error => reject(error)
                  );
                })
              ]).then(() => resolve());
            },
            error => {
              reject(error);
            }
          );
        }),
        // new Promise((resolve, reject) => {
        //   api.getCurrentSemester(
        //     state.user.department,
        //     semester => {
        //       commit('setSemester', semester);
        //       Promise.all([
        //         new Promise((resolve1, reject1) => {
        //           api.getExperiments(
        //             semester,
        //             experiments => {
        //               commit('setExperiments', experiments);
        //               resolve1();
        //             },
        //             error => reject1(error)
        //           );
        //         }),
        //         new Promise((resolve2, reject2) => {
        //           api.getLessons(
        //             '',
        //             '',
        //             semester,
        //             state.user.role === 'teacher' ? state.user.id : '',
        //             '',
        //             '',
        //             lessons => {
        //               commit('setLessons', lessons);
        //               if (lessons.length > 0) {
        //                 let selectedLessons = lessons.slice(0, 1);
        //                 Promise.all([
        //                   dispatch('selectLessons', selectedLessons),
        //                   dispatch(
        //                     'fetchDeductions',
        //                     selectedLessons[0].experiment
        //                   )
        //                 ]).then(() => {
        //                   resolve2();
        //                 });
        //               }
        //               resolve2();
        //             },
        //             error => {
        //               reject2(error);
        //             }
        //           );
        //         })
        //       ]).then(() => {
        //         resolve();
        //       });
        //     },
        //     error => {
        //       reject(error);
        //     }
        //   );
        // }),
        new Promise((resolve, reject) => {
          api.getUsers(
            'teacher',
            state.user.org,
            teachers => {
              commit('setTeachers', teachers);
              resolve();
            },
            error => reject(error)
          );
        })
      ]);
    },
    async fetchCourses({ commit }, { org_id, semester_id }) {
      await api.getCourses(
        org_id,
        semester_id,
        courses => {
          commit('setCourses', courses);
          Promise.resolve();
        },
        error => Promise.reject(error)
      );
    },
    async fetchProjects({ commit }, { org_id, semester_id }) {
      await api.getExperiments(
        org_id,
        semester_id,
        experiments => {
          commit('setExperiments', experiments);
          Promise.resolve();
        },
        error => Promise.reject(error)
      );
    },
    async selectLessons({ state, dispatch, commit }, lessons) {
      commit('setSelectedLessons', lessons);
      return Promise.all(
        lessons.map(async lesson => {
          return new Promise((resolve, reject) => {
            api.getLessonElectives(
              lesson.id,
              electives => {
                let group = {
                  name: lesson.projects.name,
                  electives: electives
                };
                // commit('addElectives', group);
                resolve(group);
              },
              () => {
                reject();
              }
            );
          });
        })
      ).then(async values => {
        commit('setElectives', values);
        if (values.length > 0) {
          const submitElectives = values[0].electives.filter(
            x => x.reports.length > 0 && x.reports[0].status === 'S'
          );
          const avaiableElectives = values[0].electives.filter(
            x =>
              x.reports.length > 0 &&
              (x.reports[0].status === 'C' || x.reports[0].status === 'Draft')
          );
          const elective =
            submitElectives.length > 0
              ? submitElectives[0]
              : avaiableElectives[0];

          if (elective) {
            if (!state.histories.length) {
              const exp = state.experiments.find(
                x => x.name === elective.projects.name
              );
              commit('setExperiment', exp);
              await dispatch('fetchReports', {
                id: elective.id,
                status: elective.reports[0].status
              }).then(() => {
                commit('setElective', elective);
                dispatch('fetchDeductions', exp.code);
              });
            }
          } else {
            commit('setElective', null);
            commit('setReports', []);
          }
        }
      });
    },
    async selectStudents({ state, dispatch, commit }, students) {
      const studentsGroup = students.map(item => ({
        name: item.name,
        electives: item.user2projects
      }));

      await commit('setSelectedStudents', students);
      await commit('setElectives', studentsGroup);

      if (studentsGroup.length > 0) {
        const submitElectives = studentsGroup[0].electives.filter(
          x => x.reports.length > 0 && x.reports[0].status === 'S'
        );
        const avaiableElectives = studentsGroup[0].electives.filter(
          x =>
            x.reports.length > 0 &&
            (x.reports[0].status === 'C' || x.reports[0].status === 'Draft')
        );
        const elective =
          submitElectives.length > 0
            ? submitElectives[0]
            : avaiableElectives[0];

        if (elective) {
          const exp = state.experiments.find(
            x => x.name === elective.projects.name
          );

          await commit('setExperiment', exp);
          await dispatch('fetchReports', {
            id: elective.id,
            status: elective.reports[0].status
          }).then(async () => {
            await commit('setElective', elective);
            await dispatch('fetchDeductions', exp.code);
          });
        } else {
          await commit('setElective', null);
          await commit('setReports', []);
        }
      }
    },
    async selectOrgs({ state, dispatch, commit }, orgs) {
      const orgsGroup = orgs.map(item => ({
        name: `${item.name}(${state.orgOptions.project_name})`,
        electives: item.user_orgs
          .map(item => item.users.user2projects[0])
          .sort((a, b) => {
            return a.user_code.localeCompare(b.user_code);
          })
      }));

      await commit('setSelectedOrgs', orgs);
      await commit('setElectives', orgsGroup);

      if (orgsGroup.length > 0) {
        const submitElectives = orgsGroup[0].electives.filter(
          x => x.reports.length > 0 && x.reports[0].status === 'S'
        );
        const avaiableElectives = orgsGroup[0].electives.filter(
          x =>
            x.reports.length > 0 &&
            (x.reports[0].status === 'C' || x.reports[0].status === 'Draft')
        );
        const elective =
          submitElectives.length > 0
            ? submitElectives[0]
            : avaiableElectives[0];

        if (elective) {
          const exp = state.experiments.find(
            x => x.name === elective.projects.name
          );

          await commit('setExperiment', exp);
          await dispatch('fetchReports', {
            id: elective.id,
            status: elective.reports[0].status
          }).then(async () => {
            await commit('setElective', elective);
            await dispatch('fetchDeductions', exp.code);
          });
        } else {
          await commit('setElective', null);
          await commit('setReports', []);
        }
      }
    },
    async fetchDeductionMarks({ commit, dispatch }) {
      await api.getDeductionMarks(
        async deductionMarks => {
          deductionMarks = deductionMarks.map(item => {
            return {
              text: item.dictvalue,
              value: item.dictkey
            };
          });
          commit('setDeductionMarks', deductionMarks);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `获取报告评分项类型失败，请稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async fetchDeductionStatus({ commit, dispatch }) {
      await api.getDeductionStatus(
        async deductionStatus => {
          deductionStatus = deductionStatus
            .map(item => {
              return {
                text: item.dictvalue,
                value: item.dictkey
              };
            })
            .filter(item => item.value !== 'preview');

          commit('setDeductionStatus', deductionStatus);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `获取报告评分项权限失败，请稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async fetchDeductions({ state, commit, getters, dispatch }, experiment) {
      await api.getDeductionItems(
        experiment,
        state.user.org,
        async deductions => {
          let map = new Map();

          deductions.forEach(item => {
            if (map.has(''.concat(item.type_order, '.', item.type))) {
              map.get(''.concat(item.type_order, '.', item.type)).push({
                ...item,
                experiment: experiment
              });
            } else {
              map.set(''.concat(item.type_order, '.', item.type), []);
              map.get(''.concat(item.type_order, '.', item.type)).push({
                ...item,
                experiment: experiment
              });
            }
          });

          commit('setDeductions', map);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `获取扣分项失败，请稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async addDeduction({ dispatch, state }, deduction) {
      return await api.addDeduction(
        deduction,
        state.user.id,
        state.user.org,
        async () => {
          if (state.experiment) {
            await dispatch('fetchDeductions', state.experiment.code);
          }

          await dispatch('alert', {
            message: '新增成功',
            color: 'success'
          });
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `创建失败，请稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async updateDeduction({ dispatch, state }, deduction) {
      return await api.updateDeduction(
        deduction,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `修改失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async submitDeduction({ dispatch, state }, id) {
      return await api.submitDeduction(
        id,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `分享失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async submitBackDeduction({ dispatch, state }, id) {
      return await api.submitBackDeduction(
        id,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `退回失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        },
        async () => {
          await dispatch('alert', {
            message: `此评分参考已经通过，不可退回。`,
            color: 'error'
          });
        }
      );
    },
    async submitBackDeductionAdmin({ dispatch, state }, id) {
      return await api.submitBackDeductionAdmin(
        id,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `退回失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async submitCheckedDeduction({ dispatch, state }, id) {
      return await api.submitCheckedDeduction(
        id,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `通过失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        },
        async () => {
          await dispatch('alert', {
            message: `此评分参考已经退回，不可通过。`,
            color: 'error'
          });
        }
      );
    },
    async deleteDeduction({ dispatch, state }, id) {
      return await api.deleteDeduction(
        id,
        async () => {
          await dispatch('fetchDeductions', state.experiment.code);
          Promise.resolve();
        },
        async error => {
          await dispatch('alert', {
            message: `删除失败，稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async fetchLessons({ dispatch, commit, getters }, options) {
      return new Promise((resolve, reject) => {
        api.getLessons(
          getters.user.org,
          options.course,
          options.experiment,
          options.address,
          options.semester,
          options.teacher,
          options.start,
          options.end,
          lessons => {
            commit('setLessons', lessons);
            resolve();
          },
          async error => {
            await dispatch('alert', {
              message: `获取场次列表失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject(error);
          }
        );
      });
    },
    async fetchStudents({ state, dispatch, commit }, options) {
      return new Promise((resolve, reject) => {
        api.getStudents(
          options.grade,
          options.codeOrName,
          students => {
            resolve(students);
          },
          async error => {
            await dispatch('alert', {
              message: '获取学生失败，请稍后再试。',
              color: 'error',
              debugInfo: error
            });
            reject(error);
          }
        );
      });
    },
    async afterFetchStudents({ state, dispatch, commit }, students) {
      const getNum = (u2ps, status) =>
        u2ps.length
          ? u2ps.filter(
              item => item.reports.length && item.reports[0].status === status
            ).length
          : 0;
      const stus = students
        .map(stu => ({
          ...stu,
          rpt_submit: getNum(stu.user2projects, 'S'),
          rpt_check: getNum(stu.user2projects, 'C'),
          rpt_sendback: getNum(stu.user2projects, 'Re'),
          rpt_draft: getNum(stu.user2projects, 'Draft'),
          total: stu.user2projects.length
            ? stu.user2projects.filter(item => item.reports.length).length
            : 0
        }))
        .sort((a, b) => {
          return a.code.localeCompare(b.code);
        });

      if (
        state.curDrawerType === 'student' &&
        !state.isOrg &&
        state.selectedStudents.length
      )
        await dispatch(
          'selectStudents',
          state.selectedStudents.reduce((acc, cur) => {
            acc.push(stus.find(item => item.id === cur.id));

            return acc;
          }, [])
        );

      await commit('setStudents', stus);
    },
    async fetchOrgs(
      { state, dispatch, commit },
      { semester_id, course_id, project_id }
    ) {
      return new Promise((resolve, reject) => {
        api.getOrgs(
          {
            semester_id: semester_id || state.semester.id,
            course_id,
            project_id
          },
          data => {
            resolve(data);
          },
          async error => {
            await dispatch('alert', {
              message: '获取班级失败，请稍后再试。',
              color: 'error',
              debugInfo: error
            });
            reject(error);
          }
        );
      });
    },
    async afterFetchOrgs({ state, dispatch, commit }, data) {
      const getNum = (u2os, status) =>
        u2os.reduce((acc, cur) => {
          cur.users.user2projects[0].reports.length &&
            cur.users.user2projects[0].reports[0].status === status &&
            ++acc;

          return acc;
        }, 0);
      let orgs = [];

      if (
        state.user.role === 'teacher' &&
        state.config.allowTeacherManageOwnClass &&
        state.curUser.class_list &&
        state.curUser.class_list.length
      ) {
        orgs = data
          .filter(item =>
            state.curUser.class_list.some(cl => cl === item.organization_id)
          )
          .map(item => ({
            ...item.orgs,
            rpt_submit: getNum(item.orgs.user_orgs, 'S'),
            rpt_check: getNum(item.orgs.user_orgs, 'C'),
            rpt_sendback: getNum(item.orgs.user_orgs, 'Re'),
            rpt_draft: getNum(item.orgs.user_orgs, 'Draft'),
            total: item.orgs.user_orgs.length
          }));
      } else if (
        state.user.role !== 'teacher' ||
        (state.user.role === 'teacher' &&
          !state.config.allowTeacherManageOwnClass)
      )
        orgs = data.map(item => ({
          ...item.orgs,
          rpt_submit: getNum(item.orgs.user_orgs, 'S'),
          rpt_check: getNum(item.orgs.user_orgs, 'C'),
          rpt_sendback: getNum(item.orgs.user_orgs, 'Re'),
          rpt_draft: getNum(item.orgs.user_orgs, 'Draft'),
          total: item.orgs.user_orgs.length
        }));

      if (
        state.curDrawerType === 'student' &&
        state.isOrg &&
        state.selectedOrgs.length
      )
        await dispatch(
          'selectOrgs',
          state.selectedOrgs.reduce((acc, cur) => {
            const org = orgs.find(item => item.id === cur.id);
            org && acc.push(org);

            return acc;
          }, [])
        );

      await commit('setOrgs', orgs);
    },
    async fetchReports({ dispatch, commit }, { id: id, status: status }) {
      let promise = [
        new Promise((resolve, reject) => {
          api.getReports(
            id,
            status,
            reports => {
              if (typeof reports === 'string') {
                commit(
                  'setReports',
                  reports
                    .replace('[', '')
                    .replace(']', '')
                    .split(',')
                );
              } else {
                commit('setReports', []);
              }

              resolve();
            },
            async error => {
              await dispatch('alert', {
                message: `获取报告失败，请稍后再试。`,
                color: 'error',
                debugInfo: error
              });
              reject(error);
            }
          );
        })
      ];
      if (status === 'C' || status === 'Draft') {
        promise.push(
          new Promise((resolve, reject) => {
            api.getCheckReports(
              id,
              reports => {
                commit(
                  'setCheckReports',
                  reports
                    .replace('[', '')
                    .replace(']', '')
                    .split(',')
                );
                resolve();
              },
              async error => {
                await dispatch('alert', {
                  message: `获取报告失败，请稍后再试。`,
                  color: 'error',
                  debugInfo: error
                });
                reject(error);
              }
            );
          })
        );
      }
      return Promise.all(promise);
    },
    async updateReportStatus({ dispatch, getters }, options) {
      return new Promise((resolve, reject) => {
        api.updateReportStatus(
          options.reports,
          options.status,
          async () => {
            if (getters.curDrawerType === 'schedule')
              await dispatch('selectLessons', getters.selectedLessons);
            resolve();
          },
          async error => {
            await dispatch('alert', {
              message: `提交失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject();
          }
        );
      });
    },
    async updateReport({ dispatch, getters }, report) {
      return new Promise((resolve, reject) => {
        api.updateReport(
          report,
          async () => {
            if (getters.curDrawerType === 'schedule')
              await dispatch('selectLessons', getters.selectedLessons);

            resolve();
          },
          async error => {
            await dispatch('alert', {
              message: `提交失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject();
          }
        );
      });
    },
    async rotateReport({ dispatch }, report) {
      return new Promise((resolve, reject) => {
        api.rotateReport(
          report,
          () => {
            resolve();
          },
          async error => {
            await dispatch('alert', {
              message: `提交旋转图像失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject();
          }
        );
      });
    },
    async deduct({ state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api.updateDeductionPoint(
          state.elective.id,
          payload,
          () => {
            resolve();
          },
          async error => {
            await dispatch('alert', {
              message: `提交批阅记录失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject();
          }
        );
      });
    },
    async fetchSendbackPoints({ dispatch, commit }) {
      return await api.getSendbackPoints(
        async sendbackPoints => {
          Promise.resolve(sendbackPoints);
          commit('setSendbackPoints', sendbackPoints);
        },
        async error => {
          await dispatch('alert', {
            message: `获取错误标签失败，请稍后重试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async addSendbackPoint({ dispatch, state }, expression) {
      return new Promise((resolve, reject) => {
        api.addSendbackPoint(
          expression,
          state.user.id,
          async () => {
            resolve();
            await dispatch('alert', {
              message: '退回原因新增成功',
              color: 'success'
            });
            await dispatch('fetchSendbackPoints');
          },
          async error => {
            await dispatch('alert', {
              message: `退回原因新增失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
            reject(error);
          }
        );
      });
    },
    async deleteSendbackPoints({ dispatch }, id) {
      await api.deleteSendbackPoints(
        id,
        async () => {
          await dispatch('alert', {
            message: '退回原因删除成功',
            color: 'success'
          });
          await dispatch('fetchSendbackPoints');
        },
        async error => {
          await dispatch('alert', {
            message: `退回原因删除失败，请稍后再试。`,
            color: 'error',
            debugInfo: error
          });
        }
      );
    },
    async sendback({ dispatch, getters }, options) {
      await dispatch('updateReportStatus', {
        reports: options.elective.id,
        status: 'Re'
      }).then(async () => {
        await api.addSendback(
          options.elective.id,
          options.checkedItems,
          options.permit,
          async () => {
            await dispatch('alert', { message: '退回成功', color: 'success' });
          },
          async error => {
            await dispatch('alert', {
              message: `退回失败，请稍后再试。`,
              color: 'error',
              debugInfo: error
            });
          }
        );
        await dispatch('reloadElective');
      });
    },
    async sendNotification({ dispatch, commit }, elective) {
      await api.addNotification(
        '催缴报告通知',
        elective.user_id,
        elective.id,
        elective.projects.organization_id
      );
      dispatch('alert', { message: '催缴报告请求已提交', color: 'success' });
    },
    async reloadElective({ getters, dispatch, commit }) {
      getters.electives.some(g => {
        let elective = null;
        let status = '';

        if (getters.elective) {
          elective = g.electives.find(e => e.id === getters.elective.id);

          if (elective && elective.reports.length > 0) {
            status = elective.reports[0].status;

            dispatch('fetchReports', {
              id: elective.id,
              status: status
            }).then(() => {
              commit('setElective', elective);
            });
          }
        }

        return true;
      });
    },
    async changeElective({ dispatch, commit, getters }, elective) {
      if (elective) {
        // 接口返回的选课信息中没有实验id，从前端存储的实验列表里查到
        let exp = getters.experiments.find(
          x => x.name === elective.projects.name
        );
        commit('setExperiment', exp);
        commit('setSelectedItem', null);
        return dispatch('fetchReports', {
          id: elective.id,
          status: elective.reports[0].status
        }).then(() => {
          commit('setElective', elective);
          dispatch('fetchDeductions', exp.code);
        });
      }
    },
    hangupDrawDeduction({ commit }, deduction) {
      commit('setHangingDrawdeduction', deduction);
    },
    showDeductionForm({ getters, commit }, deduction) {
      if (deduction) {
        commit('setDeduction', {
          id: deduction.id,
          mark: deduction.mark,
          pub_status: deduction.pub_status,
          description: deduction.description,
          hide_comment: deduction.hide_comment,
          notes: deduction.notes,
          scores: deduction.scores,
          hide_score: deduction.hide_score,
          order: deduction.order,
          type: deduction.type,
          type_order: deduction.type_order,
          experiment: deduction.experiment,
          isCommon: deduction.isCommon,
          creater: deduction.creater,
          color: deduction.color
        });
      } else {
        commit('setDeduction', {
          mark: 'error',
          pub_status: 'public',
          description: '',
          notes: '',
          scores: [],
          order: 1,
          type: '',
          type_order: 1,
          experiment: getters.experiment,
          isCommon: false,
          color: '#FF0000'
        });
      }
      commit('setDeductionShow', true);
    },
    showDeductionTypeForm({ commit }) {
      commit('setDeductionTypeShow', true);
    },
    selectDrawerType({ commit }, type) {
      commit('setDrawerType', type);
    },
    selectCurDrawerType({ commit }, type) {
      commit('setCurDrawerType', type);
    },
    selectIsOrg({ commit }, status) {
      commit('setIsOrg', status);
    },
    alert({ state, commit }, { message, color, debugInfo }) {
      commit('setAlert', { message, color });
      setTimeout(() => {
        commit('resetAlert');
      }, state.alertTimeout);
      if (process.env.ENVIROMENT === 'develop' && debugInfo) {
        window && window.console.debug(debugInfo);
      }
    },
    addDeductionHistory({ commit }) {
      commit('setDeductionHistory');
    },
    changeSelectedItem({ commit }, item) {
      commit('setSelectedItem', item);
    },
    sendbackReport({ commit }, canvasArray) {
      // 对画布数组进行安全序列化，避免循环引用
      const serializedArray = canvasArray.map(item => {
        if (item && item.canvas) {
          try {
            const json = item.canvas.toJSON(['eindex', 'score']);
            return {
              ...item,
              canvas: JSON.stringify(json)
            };
          } catch (error) {
            console.error('Canvas serialization failed:', error);
            return {
              ...item,
              canvas: null
            };
          }
        }
        return item;
      });
      commit('setCanvasArray', serializedArray);
    }
  },
  plugins: [createStorage]
});
